import { useEffect, useMemo, useState } from "react";
import { Tip, TipType } from "src/components/Tipping/TipModule";

type UseTippingProps = {
    initialAmount: string;
};

export const useTipping = ({ initialAmount }: UseTippingProps) => {
    const tips: Tip[] = useMemo(
        () => [
            { type: TipType.FIRST_TIP, amount: 5, label: "5%" },
            { type: TipType.SECOND_TIP, amount: 10, label: "10%" },
            { type: TipType.THIRD_TIP, amount: 20, label: "20%" },
        ],
        []
    );

    const [activeTip, setActiveTip] = useState<TipType>(); // Default active tip
    const [tipAmount, setTipAmount] = useState<string | undefined>(undefined); // Default active tip

    const handleTipSelect = async (selectedTip: TipType) => {
        if (selectedTip === activeTip) {
            setActiveTip(TipType.NO_TIP);
            return;
        }
        setActiveTip(selectedTip); // Update the active tip
    };

    useEffect(() => {
        if (activeTip === TipType.NO_TIP) {
            setTipAmount("0"); // Reset the tip amount
            return;
        }

        // find the tip from `tips` based on type of `activeTip`
        const tip = tips.find((tip) => tip.type === activeTip);
        if (!tip) {
            return;
        }

        // calculate the tip amount
        const amount = parseFloat(initialAmount) * (tip.amount / 100);
        const formattedAmount = amount.toFixed(2);

        console.log("[ useTipping ]", { formattedAmount });
        setTipAmount(formattedAmount);
    }, [activeTip, setTipAmount, initialAmount, tips]);

    return {
        handleTipSelect,
        activeTip,
        tips,
        tipAmount,
    };
};
